export function clearLoginDetailsFromLocalStorage () {
  localStorage.removeItem('token')
  localStorage.removeItem('isLogin')
}

// function checks if the local storage contains is Login as true and has value for token
export function isLoginAndHasToken () {
  // console.log('localStorage', localStorage.getItem('isLogin'), typeof (localStorage.getItem('isLogin')))
  // console.log('localStorage', localStorage.getItem('token'))
  // console.log('localStorage', localStorage.getItem('isLogin') == 'true' && !!localStorage.getItem('token'))
  return localStorage.getItem('isLogin') == 'true' && !!localStorage.getItem('token')
}